<template>
    <div>
        <modal class="new-modal-default modal-outboxdd" :name="modal_name" transition="nice-modal-fade" :delay="100" height="auto"
            :pivot-y="0.5" :adaptive="true" :scrollable="false" style="pointer-events:inherit !important" 
            v-bind:click-to-close="false">
            <div class="v-modal-content" style="background-color: #ffffff !important;border-radius: 11px !important">
                <!-- Header Section -->
                <div class="v-modal-header">
                    <span class="v-modal-dialog-title v-modal-title">
                        <span>Schedule Meeting</span>
                        <!-- <span v-if="view_mode == 'edit'">EDIT</span>
                        <span v-if="view_mode == 'view'">VIEW</span> -->
                    </span>
                    <div>
                        <span class="icon icon-close mr-2 text-white pointer close-left"
                            @click="hideScheduleMeeting"></span>
                    </div>
                </div>
                <div class="v-modal-body">
                    <div class="fs-14 fw-500 px-6 bg-color py-2 mb-6">General Information</div>
                    <div class="v-modal-layout px-2">
                        <div>
                            <span class="text-secondary fs-14 fw-600 ml-2">Meeting Title<sup class="text-danger fs-14 ml-02">*</sup></span>
                            <textarea-autosize v-validate="'required'" name="meeting_title" :disabled="preview_screen"
                                class="digi-textarea white-background bordered mt-3" maxlength="50"
                                v-model="meeting_title" placeholder="Enter Title" style="height: 3em;" />
                            <!-- <span class="input-field-length float-right">{{ meeting_title.length }}/50</span> -->
                            <span class="text-danger pl-2" v-show="errors.has('meeting_title')"
                                style="text-transform: none !important;">Meeting Title is Required</span>
                        </div>
                    </div>
                    <div class="row mt-6 px-2">
                        <div class="col-lg-4 col-md-4 col-sm-12">
                            <div class="text-secondary fw-600 mt-3 fs-14 ml-2">Counterparty (Customer Name)<sup class="text-danger fs-14 ml-02">*</sup></div>
                            <div class="d-flex flex-column" style="position: relative;margin-top: 1.1rem !important;">
                                <multiselect :max="10"
                                    class="diginew-multiselect" style="line-height: 1.2 !important;"
                                    placeholder="Select Company" name="counterparty" v-validate="'required'"
                                    label="customer_name" open-direction="bottom" :disabled="preview_screen"
                                    v-model="counterparty" :loading="customer_loading" @search-change="searchCustomer"
                                    :options="counterparty_options" track-by="customer_name" @select="addInvitees($event)"
                                    :multiple="false" :searchable="true" :internal-search="true"
                                    :clear-on-select="false" :close-on-select="true" :options-limit="3000"
                                    :max-height="200" :show-no-results="true" :hide-selected="false"
                                    :blockKeys="['Delete']" :limit="1" :limit-text="limitCounterparty"
                                >
                                    <template slot="option" slot-scope="props" class="d-flex">
                                        {{ props.option.customer_name }}
                                    </template>
                                    <template slot="afterList">
                                        <div v-observe-visibility="reachedEndOfListCounterparty" />
                                    </template>
                                    <template slot="noOptions">
                                        <div class="text-secondary text-center fw-600">Counterparty Not Found</div>
                                    </template>
                                    <template slot="noResult">
                                        <div class="text-secondary text-center fw-600">No Results Found</div>
                                    </template>
                                </multiselect>
                            </div>
                            <span class="text-danger float-left pl-2" v-show="errors.has('counterparty')" style="text-transform: none !important;">Counterparty is Required</span>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12">
                            <div class="d-flex">
                                <div class="row">
                                    <div class="col-lg-7 col-md-7 col-sm-12 mt-3">
                                        <div class="w-100">
                                            <span class="text-secondary fw-600 fs-14 ml-2">Start Date<sup class="text-danger fs-14 ml-02">*</sup></span>
                                            <div class="d-flex align-items-center"
                                                style="margin-top: .7rem !important;">
                                                <date-picker v-validate="'required'" :disabled="preview_screen"
                                                    :not-before="new Date(new Date(all_day == true ? disable_today_date : new Date()))" name="schedule_start_date" @change="checkDate"
                                                    class="meetinfdatetime fullBorderCalendar mx-left calendar-edit-per mt-1"
                                                    v-model="schedule_start_date" value-type="format" lang="en"
                                                    type="date" format="YYYY-MM-DD" :clearable="false" 
                                                    :editable="false"></date-picker>
                                            </div>
                                            <div class="text-danger float-left pl-2"
                                                v-show="errors.has('schedule_start_date')"
                                                style="text-transform: none !important;">Date is Required</div>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-md-5 col-sm-12 mt-3"
                                        :class="{ 'hide-state' : allDayTime}">
                                        <div class="w-100">
                                            <span class="text-secondary fw-600 fs-14 ml-2">Start Time</span>
                                            <el-select v-validate="!allDayTime ? {required:true} : {required:false}" name="schedule_start_time"
                                                class="mt-3 schedule_time" :disabled="preview_screen || allDayTime" v-model="schedule_start_time"
                                                style="border-radius: 6px;border: 1px solid rgb(92 92 92) !important;"
                                                placeholder="Start Time" :popper-append-to-body="false">
                                                <el-option v-for="(item, index) in start_time_format" :key="index"
                                                    :label="item" :value="item">
                                                </el-option>
                                            </el-select>
                                            <div class="text-danger float-left pl-2"
                                                v-show="errors.has('schedule_start_time')"
                                                style="text-transform: none !important;">Time is Required</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex w-100 mt-4 align-items-center">
                                <el-checkbox v-model="all_day" :disabled="preview_screen" @change="allDayChecked"></el-checkbox>
                                <span class="ml-2" style="margin-top: -5px !important;">All Day</span>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12">
                            <div class="d-flex">
                                <div class="row">
                                    <div class="col-lg-7 col-md-7 col-sm-12 mt-3">
                                        <div class="w-100">
                                            <span class="text-secondary fw-600 fs-14 ml-2">End Date</span>
                                            <div class="d-flex align-items-center"
                                                style="margin-top: .7rem !important;">
                                                <date-picker v-validate="'required'" :disabled="preview_screen" @change="checkEndDate"
                                                    name="schedule_end_date" :not-before="new Date(schedule_start_date)"
                                                    class="meetinfdatetime fullBorderCalendar mx-left calendar-edit-per mt-1"
                                                    v-model="schedule_end_date" value-type="format" lang="en"
                                                    type="date" format="YYYY-MM-DD" :clearable="false"
                                                    :editable="false"></date-picker>
                                            </div>
                                            <div class="text-danger float-left pl-2"
                                                v-show="errors.has('schedule_end_date')"
                                                style="text-transform: none !important;">Date is Required</div>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-md-5 col-sm-12 mt-3"
                                        :class="{ 'hide-state' : allDayTime}">
                                        <div class="w-100">
                                            <span class="text-secondary fw-600 fs-14 ml-2">End Time</span>
                                            <el-select v-validate="!allDayTime ? {required:true} : {required:false}" name="schedule_end_time"
                                                class="mt-3 schedule_time" :disabled="preview_screen || allDayTime" v-model="schedule_end_time"
                                                style="border-radius: 6px;border: 1px solid rgb(92 92 92) !important;"
                                                placeholder="End Time" :popper-append-to-body="false">
                                                <el-option v-for="(item, index) in end_time_format" :key="index"
                                                    :label="item" :value="item">
                                                </el-option>
                                            </el-select>
                                            <div class="text-danger float-left pl-2"
                                                v-show="errors.has('schedule_end_time')"
                                                style="text-transform: none !important;">Time is Required</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="px-2 mt-5">
                        <!-- <div class="text-black fw-600 invite-text fs-14">Invite<sup class="fs-14 ml-02 text-danger">*</sup></div> -->
                        <span class="text-secondary fw-600 fs-14 ml-2">Invitees<sup class="text-danger fs-14 ml-02">*</sup></span>
                        <div class="d-flex flex-column mt-5" style="position: relative;margin-top: 1rem !important;">
                            <multiselect :max="10" :disabled="preview_screen" :hide-selected="true" v-validate="'required'" name="invites" class="diginew-multiselect-lightgrey sch-meeting ht_arrow-n custom-prod-ms greyblack icon-height diginew-multiselect-dark-grey" placeholder="Select Invitees"  v-model="invitees" :multiple="true" :close-on-select="true" :show-labels="false" :options="invite_options" :loading="employees_loading" @search-change="searchInvitees" label="email" track-by="email" @select="selectInvitees($event)">
                                <template slot="option" slot-scope="props" class="d-flex">
                                    {{ props.option.email }}
                                </template>
                                <template slot="afterList">
                                    <div v-observe-visibility="reachedEndOfListInvitees" />
                                </template>
                                <template slot="noOptions">
                                    <div class="text-secondary text-center fw-600">Invitees Not Found</div>
                                </template>
                                <template slot="noResult">
                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                </template>
                            </multiselect>
                            <i class="icon-account-plus" style="color: #cdd2da; position: absolute; right: 0; margin-top: 9px; margin-right: 6px;"></i>
                        </div>
                        <span class="text-danger float-left val-mes mt-9 pl-2" v-show="errors.has('invites')" style="text-transform: none !important;">Invitees is Required</span>
                    </div>
                    <div class="px-2 mt-15">
                        <!-- <div class="text-black fw-600 invite-text fs-14">Invite<sup class="fs-14 ml-02 text-danger">*</sup></div> -->
                        <div class="text-secondary fw-600 fs-14"><span class="ml-2">Other Invitees</span>
                            <div class="d-flex flex-column mt-2" style="position: relative;">
                                <vue-tags-input class="input-height email-text-valid" v-validate="'email'"
                                    :disabled="preview_screen" name="other_invitees" placeholder=""
                                    v-model="tag"
                                    :tags="tags"
                                    @tags-changed="newTags => tags = newTags"
                                />
                                <i class="icon-account-plus" style="color: #cdd2da; position: absolute; right: 0; margin-top: 9px; margin-right: 6px;"></i>
                            </div>
                            <span class="text-danger float-left mt-2 pl-2" v-show="errors.has('other_invitees')" style="text-transform: none !important;">Please Enter Valid Email Address</span>
                        </div>
                    </div>
                    <div class="v-modal-layout px-2 mt-10">
                        <div class="text-secondary fw-600 fs-14 ml-2">Description</div>
                        <textarea-autosize :disabled="preview_screen" class="bg-transparent px-2 pt-1 pb-6 mt-1 description" style="margin-top: 1rem !important;"
                            v-model="description" placeholder="Add Description" :min-height="80" :max-height="80"
                            maxlength="200" data-vv-scope="profile_data" data-vv-as="About" name="about" />
                        <span class="input-field-length float-right">{{ description.length }}/200</span>

                    </div>
                    <div class="px-2 mt-8">
                        <div class="fs-14 fw-500 px-6 bg-color py-2 mb-2">Meeting Agenda Details</div>
                        <div v-if="!preview_screen">
                            <button class="btn btn-new-primary btn-smm float-right" :disabled="preview_screen || meeting_notes_table.length > 1" @click="addOneTable"><img class="mr-2" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/table-white.svg" height="14px"> Add Table</button>
                        </div>
                    </div>
                    <div class="mt-14" v-if="!preview_screen">
                        <div v-for="(table,index) in meeting_notes_table" :key="index" class="table-box mx-2 px-4 mt-4">
                            <div
                                class="d-flex flex-wrap align-items-center justify-content-between flex-wrap">
                                <div class="mt-5">
                                    <span
                                        class="text-secondary whiteSpace fs-14 fw-600" style="color: #0475f3 !important;">Table
                                        Name :</span>
                                    <input type="text" class="px-2 ml-3" placeholder="Enter Table Name" v-validate="'required'"
                                        v-model="table.table_name" :disabled="preview_screen" :name="'table_name'+index" @click="tableData(index)"
                                        style="border-bottom: 1px solid rgba(0, 0, 0, 0.41); height: 25px;" />
                                        <div class="">
                                            <span class="text-danger mb-3" v-show="errors.has('table_name'+index)">Table Name is Required</span>
                                        </div>
                                </div>
                                <div class="mt-5">
                                    <span
                                        class="text-black whiteSpace fs-14 fw-600 ml-3 mb-2">No
                                        of Rows:
                                        <sup lass="fs-14 ml-02 mandatory">
                                            <el-tooltip content="Maximum of 10 Rows"
                                                placement="top">
                                                <i class="icon-information text-secondary"
                                                    style="font-size: 14px"></i>
                                            </el-tooltip>
                                        </sup>
                                    </span>
                                    <input type="text" class="text-center ml-3 mb-2"  :name="'table'+index" v-validate="'required'"
                                        onkeypress="return event.charCode >= 48 && event.charCode <= 57" @click="tableData(index)"
                                        v-model.number="table.rows" :disabled="preview_screen" placeholder="Rows"
                                        @input="table.rows > 10 ? table.rows = 10 : table.rows < 0 ? table.rows = 0 : '', editTable(index)"
                                        style="border-bottom: 1px solid rgba(0, 0, 0, 0.41); height: 25px; width: 70px;" />
                                    <span
                                        class="text-black whiteSpace fs-14 fw-600 ml-3 mb-2">No
                                        of Columns:
                                        <sup lass="fs-14 ml-02 mandatory">
                                            <el-tooltip content="Maximum of 5 Columns"
                                                placement="top">
                                                <i class="icon-information text-secondary"
                                                    style="font-size: 14px"></i>
                                            </el-tooltip>
                                        </sup>
                                    </span>
                                    <input type="text" class="text-center ml-3 mb-2" :name="'table'+index" v-validate="'required'"
                                        onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                        v-model.number="table.cols" :disabled="preview_screen" placeholder="Columns"
                                        @input="table.cols > 5 ? table.cols = 5 : table.cols < 0 ? table.cols = 0 : '', editTable(index)"
                                        style="border-bottom: 1px solid rgba(0, 0, 0, 0.41); height: 25px; width: 70px;" />
                                    <button class="btn btn-new-danger btn-smm ml-20" :disabled="table.table_data_index"
                                        @click="deleteTableCells(index)">- Delete</button>
                                    <button class="btn btn-new-green btn-smm ml-3"
                                        @click="addTableCells(index)"><img
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/circle-right.svg">
                                        Apply</button>
                                    <div class="">
                                        <span class="text-danger mb-3" v-show="errors.has('table'+index)">Rows And Columns Required</span>
                                    </div>
                                    <div class="">
                                        <span class="text-danger mb-3" v-if="table.table_data_index && table.rows !='' && table.cols !=''">Please Click On Apply Button</span>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-4" v-if="table.meeting_table_data == false">
                                <span class="text-danger mb-3">Table data Required</span>
                            </div>
                            <div style="overflow: auto;" v-if="table" class="pb-4">
                                <table class="meeting-table mt-10" style="width: 100%;">
                                    <tbody>
                                        <tr v-for="(row,index) in table.table_data"
                                            :key="index">
                                            <td v-for="(col,index) in row" :key="index"
                                                style="height: 38px;">
                                                <input type="text" :name="'table_data'+index" v-validate="'required'" maxlength="100" :disabled="preview_screen" v-model="row[index]" style="width:100%;" placeholder="Enter Name"/>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="pb-4">
                                <span class="text-danger pl-2" v-show="errors.has('table_data'+index)">All fields are Required</span>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="table-div mt-8 mx-4 p-4" v-for="(table,index) in meeting_notes_table" :key="index">
                            <div class="fs-14 fw-500 px-6 bg-color py-2">{{table.table_name}}</div>
                            <div style="overflow: auto;">
                                <table class="meeting-notes-table mt-4" style="width: 100%;">
                                    <tbody>
                                        <tr v-for="(row,index) in table.table_data"
                                            :key="index">
                                            <td v-for="(col,index) in row" :key="index"
                                                style="height: 38px;">
                                                <input type="text" maxlength="100" :disabled="preview_screen" v-model="row[index]" style="width:100%;padding: 0 15px 0 15px;" placeholder="Enter Name"/>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-wrap justify-content-between px-4 py-4">
                    <div>
                        <div class="d-flex w-100 mt-4 align-items-center px-5">
                            <el-checkbox v-model="add_cal" :disabled="preview_screen" @change="addGoogleCal"></el-checkbox>
                            <span class="ml-2" style="margin-top: -5px !important;">Add to Google Calendar</span>
                        </div>
                    </div>
                    <div style="text-align: center !important;" v-if="!preview_screen">
                        <button class="btn new-cancel-button ml-2 mr-2" @click="hideScheduleMeeting">Cancel</button>
                        <button class="btn btn-new-primary ml-2 mr-2 text-capitalize" :disabled="fields_not_changed_bus || table_data_index"  style="border-radius: 4px;" @click="previewSchedule">Preview</button>
                    </div>
                    <div style="text-align: center !important;" v-else>
                        <button class="btn new-back-button ml-2 mr-2" :disabled="schedule_loading" @click="previwBack"><i class="icon icon-chevron-left icon-chevron-right-menubar" style="color: #00448b;"></i>Back</button>
                        <button class="btn new-save-button ml-2 mr-2 text-capitalize" :disabled="schedule_loading" style="border-radius: 4px;" @click="SaveSchedule">Save
                            <hollow-dots-spinner v-if="schedule_loading" style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" /></button>
                    </div>
                    <div>
                        <div class="d-flex w-100 mt-4 align-items-center px-5">
                            <span class="ml-2 text-white" style="margin-top: -5px !important;">Add to Google Calendar</span>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
    import axios from "axios";
    import VueTagsInput from "@johmun/vue-tags-input";
    import { SweetModal } from 'sweet-modal-vue';
    import leads from "../mixins/leads"
    import {debounce} from 'lodash';
    import customer from "../mixins/customer.js"
    import schedule from "../mixins/scheduleMeeting.js"
    import { HollowDotsSpinner } from "epic-spinners";
    import moment from 'moment';
    export default ({
        props: ["modal_name", "meeting_data_id", "view_mode", "module_type", "reference_id", "lead_current_stage"],
        mixins: [leads, customer, schedule],
        data() {
            return {
                counterparty_options: [],
                invite_options: [],
                template_options: [],
                // other_invite_options: [],
                
                meeting_title: "",
                counterparty:"",
                schedule_start_date: null,
                schedule_start_time: null,
                schedule_end_date: null,
                schedule_end_time: null,
                invitees: [],
                tags: [],
                tag: "",
                description: "",
                meeting_notes_table: [],
                start_time_format: [
                    '00:00',
                    '00:15',
                    '00:30',
                    '00:45',
                    '01:00',
                    '01:15',
                    '01:30',
                    '01:45',
                    '02:00',
                    '02:15',
                    '02:30',
                    '02:45',
                    '03:00',
                    '03:15',
                    '03:30',
                    '03:45',
                    '04:00',
                    '04:15',
                    '04:30',
                    '04:45',
                    '05:00',
                    '05:15',
                    '05:30',
                    '05:45',
                    '06:00',
                    '06:15',
                    '06:30',
                    '06:45',
                    '07:00',
                    '07:15',
                    '07:30',
                    '07:45',
                    '08:00',
                    '08:15',
                    '08:30',
                    '08:45',
                    '09:00',
                    '09:15',
                    '09:30',
                    '09:45',
                    '10:00',
                    '10:15',
                    '10:30',
                    '10:45',
                    '11:00',
                    '11:15',
                    '11:30',
                    '11:45',
                    '12:00',
                    '12:15',
                    '12:30',
                    '12:45',
                    '13:00',
                    '13:15',
                    '13:30',
                    '13:45',
                    '14:00',
                    '14:15',
                    '14:30',
                    '14:45',
                    '15:00',
                    '15:15',
                    '15:30',
                    '15:45',
                    '16:00',
                    '16:15',
                    '16:30',
                    '16:45',
                    '17:00',
                    '17:15',
                    '17:30',
                    '17:45',
                    '18:00',
                    '18:15',
                    '18:30',
                    '18:45',
                    '19:00',
                    '19:15',
                    '19:30',
                    '19:45',
                    '20:00',
                    '20:15',
                    '20:30',
                    '20:45',
                    '21:00',
                    '21:15',
                    '21:30',
                    '21:45',
                    '22:00',
                    '22:15',
                    '22:30',
                    '22:45',
                    '23:00',
                    '23:15',
                    '23:30',
                    '23:45',
                ],
                end_time_format: [
                    '00:00',
                    '00:15',
                    '00:30',
                    '00:45',
                    '01:00',
                    '01:15',
                    '01:30',
                    '01:45',
                    '02:00',
                    '02:15',
                    '02:30',
                    '02:45',
                    '03:00',
                    '03:15',
                    '03:30',
                    '03:45',
                    '04:00',
                    '04:15',
                    '04:30',
                    '04:45',
                    '05:00',
                    '05:15',
                    '05:30',
                    '05:45',
                    '06:00',
                    '06:15',
                    '06:30',
                    '06:45',
                    '07:00',
                    '07:15',
                    '07:30',
                    '07:45',
                    '08:00',
                    '08:15',
                    '08:30',
                    '08:45',
                    '09:00',
                    '09:15',
                    '09:30',
                    '09:45',
                    '10:00',
                    '10:15',
                    '10:30',
                    '10:45',
                    '11:00',
                    '11:15',
                    '11:30',
                    '11:45',
                    '12:00',
                    '12:15',
                    '12:30',
                    '12:45',
                    '13:00',
                    '13:15',
                    '13:30',
                    '13:45',
                    '14:00',
                    '14:15',
                    '14:30',
                    '14:45',
                    '15:00',
                    '15:15',
                    '15:30',
                    '15:45',
                    '16:00',
                    '16:15',
                    '16:30',
                    '16:45',
                    '17:00',
                    '17:15',
                    '17:30',
                    '17:45',
                    '18:00',
                    '18:15',
                    '18:30',
                    '18:45',
                    '19:00',
                    '19:15',
                    '19:30',
                    '19:45',
                    '20:00',
                    '20:15',
                    '20:30',
                    '20:45',
                    '21:00',
                    '21:15',
                    '21:30',
                    '21:45',
                    '22:00',
                    '22:15',
                    '22:30',
                    '22:45',
                    '23:00',
                    '23:15',
                    '23:30',
                    '23:45',
                ],
                allDayTime: false,
                employees_loading: false,
                temp_employees: [],
                employee_count: 0,
                employee_scrollable: false,
                employee_visible: false,
                store_invitees: [],
                all_day: false,
                add_cal: false,
                addGoogle: false,
                counterparty_options:[],
                customer_loading: false,
                customer_count: 0,
                customer_scrollable: false,
                temp_customer: [],
                customer_visible: false,
                schedule_loading: false,
                success_msg: "",
                warning_msg: "",
                preview_screen: false,
                stringified_bus_response: "",
                temp_meeting_template_data: [],
                temp_selected_invitees: [],
                temp_table_details: [],
                disable_repeat_start_date: "",
                selectedCustomer: [],
                meeting_table_data: false,
                table_data_index: false,
            }
        },
        components: {SweetModal, HollowDotsSpinner, VueTagsInput},
        created() {
            this.searchInvitees = debounce(this.searchInviteesDebouncer, 500)
            this.searchCustomer = debounce(this.searchCounterpartyDebouncer, 500)
        },
        methods: {
            tableData(index){
               if(this.meeting_notes_table[index].table_data == ''){
                this.meeting_notes_table[index].meeting_table_data = false
               }else{
                this.meeting_notes_table[index].meeting_table_data = true
                this.meeting_table_data = true
               }
            },
            editTable(index){
                this.meeting_notes_table[index].table_data_index = true
                this.table_data_index = true
            },
            checkEndDate(){
                this.schedule_end_time = "";
                this.end_time_format = [
                    '00:00',
                    '00:15',
                    '00:30',
                    '00:45',
                    '01:00',
                    '01:15',
                    '01:30',
                    '01:45',
                    '02:00',
                    '02:15',
                    '02:30',
                    '02:45',
                    '03:00',
                    '03:15',
                    '03:30',
                    '03:45',
                    '04:00',
                    '04:15',
                    '04:30',
                    '04:45',
                    '05:00',
                    '05:15',
                    '05:30',
                    '05:45',
                    '06:00',
                    '06:15',
                    '06:30',
                    '06:45',
                    '07:00',
                    '07:15',
                    '07:30',
                    '07:45',
                    '08:00',
                    '08:15',
                    '08:30',
                    '08:45',
                    '09:00',
                    '09:15',
                    '09:30',
                    '09:45',
                    '10:00',
                    '10:15',
                    '10:30',
                    '10:45',
                    '11:00',
                    '11:15',
                    '11:30',
                    '11:45',
                    '12:00',
                    '12:15',
                    '12:30',
                    '12:45',
                    '13:00',
                    '13:15',
                    '13:30',
                    '13:45',
                    '14:00',
                    '14:15',
                    '14:30',
                    '14:45',
                    '15:00',
                    '15:15',
                    '15:30',
                    '15:45',
                    '16:00',
                    '16:15',
                    '16:30',
                    '16:45',
                    '17:00',
                    '17:15',
                    '17:30',
                    '17:45',
                    '18:00',
                    '18:15',
                    '18:30',
                    '18:45',
                    '19:00',
                    '19:15',
                    '19:30',
                    '19:45',
                    '20:00',
                    '20:15',
                    '20:30',
                    '20:45',
                    '21:00',
                    '21:15',
                    '21:30',
                    '21:45',
                    '22:00',
                    '22:15',
                    '22:30',
                    '22:45',
                    '23:00',
                    '23:15',
                    '23:30',
                    '23:45',
                ]
                var curr_date = this.schedule_end_date
                if(this.schedule_start_date == curr_date){
                    var temp_start_time = ""
                    var curr_time = this.schedule_start_time
                    if(parseInt(curr_time.substring(3)) >= 0 && parseInt(curr_time.substring(3)) < 15){
                        temp_start_time = curr_time.slice(0,3) + '00'
                    } else if(parseInt(curr_time.substring(3)) >= 15 && parseInt(curr_time.substring(3)) < 30){
                        temp_start_time = curr_time.slice(0,3) + '15'
                    } else if(parseInt(curr_time.substring(3)) >= 30 && parseInt(curr_time.substring(3)) < 45){
                        temp_start_time = curr_time.slice(0,3) + '30'
                    } else if(parseInt(curr_time.substring(3)) >= 45){
                        temp_start_time = curr_time.slice(0,3) + '45'
                    }
                    let indx = this.end_time_format.indexOf(temp_start_time)
                    this.end_time_format.splice(0,indx+1)
                }
                let startDate = new Date(this.schedule_end_time)
                startDate.setDate(startDate.getDate() + 1)
                this.disable_repeat_start_date = startDate
            },
            checkDate(){
                this.schedule_end_date = "";
                this.schedule_start_time = "";
                this.schedule_end_time = "";
                this.start_time_format = [
                    '00:00',
                    '00:15',
                    '00:30',
                    '00:45',
                    '01:00',
                    '01:15',
                    '01:30',
                    '01:45',
                    '02:00',
                    '02:15',
                    '02:30',
                    '02:45',
                    '03:00',
                    '03:15',
                    '03:30',
                    '03:45',
                    '04:00',
                    '04:15',
                    '04:30',
                    '04:45',
                    '05:00',
                    '05:15',
                    '05:30',
                    '05:45',
                    '06:00',
                    '06:15',
                    '06:30',
                    '06:45',
                    '07:00',
                    '07:15',
                    '07:30',
                    '07:45',
                    '08:00',
                    '08:15',
                    '08:30',
                    '08:45',
                    '09:00',
                    '09:15',
                    '09:30',
                    '09:45',
                    '10:00',
                    '10:15',
                    '10:30',
                    '10:45',
                    '11:00',
                    '11:15',
                    '11:30',
                    '11:45',
                    '12:00',
                    '12:15',
                    '12:30',
                    '12:45',
                    '13:00',
                    '13:15',
                    '13:30',
                    '13:45',
                    '14:00',
                    '14:15',
                    '14:30',
                    '14:45',
                    '15:00',
                    '15:15',
                    '15:30',
                    '15:45',
                    '16:00',
                    '16:15',
                    '16:30',
                    '16:45',
                    '17:00',
                    '17:15',
                    '17:30',
                    '17:45',
                    '18:00',
                    '18:15',
                    '18:30',
                    '18:45',
                    '19:00',
                    '19:15',
                    '19:30',
                    '19:45',
                    '20:00',
                    '20:15',
                    '20:30',
                    '20:45',
                    '21:00',
                    '21:15',
                    '21:30',
                    '21:45',
                    '22:00',
                    '22:15',
                    '22:30',
                    '22:45',
                    '23:00',
                    '23:15',
                    '23:30',
                    '23:45',
                ]
                var curr_date = moment(new Date().toUTCString()).format("YYYY-MM-DD")
                if(this.schedule_start_date == curr_date){
                    var temp_start_time = ""
                    var curr_time = moment(new Date().toUTCString()).format("HH:mm");
                    if(parseInt(curr_time.substring(3)) >= 0 && parseInt(curr_time.substring(3)) < 15){
                        temp_start_time = curr_time.slice(0,3) + '00'
                    } else if(parseInt(curr_time.substring(3)) >= 15 && parseInt(curr_time.substring(3)) < 30){
                        temp_start_time = curr_time.slice(0,3) + '15'
                    } else if(parseInt(curr_time.substring(3)) >= 30 && parseInt(curr_time.substring(3)) < 45){
                        temp_start_time = curr_time.slice(0,3) + '30'
                    } else if(parseInt(curr_time.substring(3)) >= 45){
                        temp_start_time = curr_time.slice(0,3) + '45'
                    }
                    let indx = this.start_time_format.indexOf(temp_start_time)
                    this.start_time_format.splice(0,indx+1)
                }
                let startDate = new Date(this.schedule_start_time)
                startDate.setDate(startDate.getDate() + 1)
                this.disable_repeat_start_date = startDate
            },
            addInvitees(data){
                this.invitees = []
                this.selectedCustomer = {}
                this.selectedCustomer = {
                    id: data.id,
                    customer_name: data.customer_name
                }
                if(data.poc_details.primary_email != ''){
                    this.invitees.push({
                        email: data.poc_details.primary_email,
                        id: data.id,
                        full_name: data.poc_details.first_name 
                    })
                }
                if(data.primary_email != ''){
                    this.invitees.push({
                        email: data.primary_email,
                        id: data.id,
                        full_name: data.customer_name 
                    })
                }
                this.temp_selected_invitees = this.invitees
            },
            previwBack(){
                this.preview_screen = false
            },
            SaveSchedule(){
                this.schedule_loading = true;
                this.$validator.validateAll().then(async result => {
                    let temp_data = false
                    if(result == true) {
                        this.schedule_loading = true;
                        this.temp_meeting_template_data = this.meeting_notes_table
                        this.temp_meeting_template_data.forEach((el_table_details, el_table_details_index) => {
                            el_table_details.table_data.forEach((el_table_data, el_table_data_index) => {
                                if(el_table_data_index == 0){
                                    this.temp_meeting_template_data[el_table_details_index].header_data = el_table_data
                                }
                            })
                        })
                        this.temp_meeting_template_data.forEach((del_table_details, del_table_details_index) => {
                            del_table_details.table_data.shift()
                        })
                        this.temp_table_details = JSON.parse(JSON.stringify(this.temp_meeting_template_data));
                        
                        let final_result =  this.temp_table_details.map(table => {
                            const result = [];
                            table.table_data.forEach(row => {
                                const obj = {};
                                table.header_data.forEach((header, index) => {
                                    obj[header] = row[index];
                                });
                                result.push(obj);
                            });
                            return result;
                        });
                        this.temp_table_details.forEach((el_one, el_one_index) => {
                            delete el_one['meeting_table_data']
                            delete el_one['table_data_index']
                            el_one.table_data = final_result[el_one_index]
                        })
                        delete this.create_schedule_meeting['_id']
                        if(this.module_type == 'tools'){
                            delete this.create_schedule_meeting['reference_id']
                            delete this.create_schedule_meeting['stage_name']
                        }else if(this.module_type == 'contacts' || this.module_type == 'customers'){
                            delete this.create_schedule_meeting['stage_name']
                        }
                        try{
                            let response = await this.createScheduleMeetings(this.create_schedule_meeting)
                            if (response.status_id == 1) {
                                this.success_msg = response.message
                                this.$refs.success_modal.open();
                                setTimeout(() => {
                                    this.hideScheduleMeeting();
                                    this.$refs.success_modal.close();
                                    this.$emit("SaveSchedule", false)
                                    this.schedule_loading = false;
                                }, 3000);
                            }else {
                                this.warning_msg = response.reason
                                setTimeout(() => {
                                    this.preview_screen = false
                                this.$refs.warning_modal.close();
                                this.$refs.warning_modal.close();
                                this.$emit("SaveSchedule", false)
                                    this.$refs.warning_modal.close();
                                this.$emit("SaveSchedule", false)
                                }, 3000);
                            }
                        } catch(error){
                            this.warning_msg = error
                            setTimeout(() => {
                                this.preview_screen = false
                                this.$refs.warning_modal.close();
                            }, 3000);
                        }
                        // }else {
                        //     this.warning_msg = response.reason
                        //     setTimeout(() => {
                        //         this.preview_screen = false
                        //         this.$refs.warning_modal.close();
                        //         this.$emit("SaveSchedule", false)
                        //     }, 3000);
                        // }
                        this.schedule_loading = false;
                    }
                })
            },
            previewSchedule (){
                this.$validator.validateAll().then(async result => {
                    let temp_data = false
                    if(result == true) {
                        this.preview_screen = true
                    }
                })
            },
            addOneTable() {
                this.meeting_notes_table.push({
                    table_name: "",
                    rows: null,
                    cols: null,
                    table_data: [],
                    meeting_table_data: false,
                    table_data_index: false
                });
            },
            addTableCells(index){
                this.meeting_notes_table[index].meeting_table_data = true
                this.meeting_table_data= true
                this.table_data_index = false
                this.meeting_notes_table[index].table_data_index = false
                // this.meeting_notes_table[index].table_loader = true;
                let row_num = this.meeting_notes_table[index].rows == null ? 1 : parseInt(this.meeting_notes_table[index].rows) + 1;
                let col_num = this.meeting_notes_table[index].cols == null ? 0 : parseInt(this.meeting_notes_table[index].cols);
                if(row_num - 1 != 0 && col_num != 0 ){
                    if(this.meeting_notes_table[index].table_data.length == 0){
                        for (let i = 0; i < row_num ; i++) {
                            let cell = [];
                            for (let j = 0; j < col_num; j++) {
                                cell[j] = ""
                            }
                            this.meeting_notes_table[index].table_data.push(cell);
                        }
                    } else {
                        if(this.meeting_notes_table[index].table_data.length <= row_num){
                            let row = row_num - this.meeting_notes_table[index].table_data.length
                            for(let i=0; i<row; i++){
                                let cell = []
                                for(let j=0; j<col_num; j++){
                                    cell.push("");
                                }
                                this.meeting_notes_table[index].table_data.push(cell);
                            }
                            this.meeting_notes_table[index].table_data.forEach((x) => {
                                if(x.length < col_num){
                                    let column = col_num - x.length
                                    for (let i =0; i < column; i++) {
                                        x.push("");
                                    }
                                } else if(x.length > col_num){
                                    let column = x.length - col_num
                                    for (let i = 0; i < column; i++) {
                                        x.pop();
                                    }
                                }
                            });
                        } else if(this.meeting_notes_table[index].table_data.length > row_num){
                            let row = this.meeting_notes_table[index].table_data.length - row_num
                            for (let i = 0; i < row; i++) {
                                let cell = [];
                                for (let i = 0; i < col_num; i++) {
                                    cell.pop();
                                }
                                this.meeting_notes_table[index].table_data.pop(cell);
                            }
                            this.meeting_notes_table[index].table_data.forEach((x) => {
                                if(x.length < col_num){
                                    let column = col_num - x.length
                                    for (let i =0; i < column; i++) {
                                        x.push("");
                                    }
                                } else if(x.length > col_num){
                                    let column = x.length - col_num
                                    for (let i = 0; i < column; i++) {
                                        x.pop();
                                    }
                                }
                            })
                        }
                    }
                } else {
                    this.warning_msg = 'Please Enter Rows and Columns'
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
                setTimeout(() => {
                    // this.meeting_notes_table[index].table_loader = false;
                }, 1000);
            },
            // addTableCells(index) {
            //     if (this.meeting_notes_table[index].table_data.length) {
            //         if (this.meeting_notes_table[index].table_data.length <= this.meeting_notes_table[index].rows) {
            //             let row = this.meeting_notes_table[index].rows - this.meeting_notes_table[index].table_data.length;
            //             for (let i =0; i <row; i++) {
            //                 let cell = [];
            //                 for (let i = 0; i < this.meeting_notes_table[index].cols; i++) {
            //                     cell.push("");
            //                 }
            //                 this.meeting_notes_table[index].table_data.push(cell);
            //             }
            //             this.meeting_notes_table[index].table_data.forEach(x => {
            //                 if (x.length < this.meeting_notes_table[index].cols) {
            //                     let column = this.meeting_notes_table[index].cols - x.length;
            //                     for (let i = 0; i < column; i++) {
            //                         x.push("");
            //                     }
            //                 } else if (x.length > this.meeting_notes_table[index].cols) {
            //                     let column = x.length - this.meeting_notes_table[index].cols;
            //                     for (let i = 0; i < column; i++) {
            //                         x.pop();
            //                     }
            //                 }
            //             });
            //         } else if (this.meeting_notes_table[index].table_data.length > this.meeting_notes_table[index].rows) {
            //             let row = this.meeting_notes_table[index].table_data.length - this.meeting_notes_table[index].rows;
            //             for (let i = 0; i < row; i++) {
            //                 let cell = [];
            //                 for (let i = 0; i < this.meeting_notes_table[index].cols; i++) {
            //                     cell.pop();
            //                 }
            //                 this.meeting_notes_table[index].table_data.pop(cell);
            //             }
            //             this.meeting_notes_table[index].table_data.forEach(x => {
            //                 if (x.length < this.meeting_notes_table[index].cols) {
            //                     let column = this.meeting_notes_table[index].cols - x.length;
            //                     for (let i = 0; i < column; i++) {
            //                         x.push("");
            //                     }
            //                 } else if (x.length > this.meeting_notes_table[index].cols) {
            //                     let column = x.length - this.meeting_notes_table[index].cols;
            //                     for (let i = 0; i < column; i++) {
            //                         x.pop();
            //                     }
            //                 }
            //             });
            //         }

            //     } else {
            //         for (let i = 0; i < this.meeting_notes_table[index].rows; i++) {
            //             let cell = [];
            //             for (let i = 0; i < this.meeting_notes_table[index].cols; i++) {
            //                 cell.push("");
            //             }
            //             this.meeting_notes_table[index].table_data.push(cell);
            //         }
            //     }
            // },
            deleteTableCells(index) {
                this.meeting_notes_table[index].table_data = [];
                this.meeting_notes_table[index].rows = 0;
                this.meeting_notes_table[index].cols = 0;
                this.meeting_notes_table[index].table_name = "";
                this.meeting_notes_table.splice(index, 1);
            },

            async searchCounterpartyDebouncer(item) {
                this.customer_loading = true
                /**@params = limit, @params = skip , @params = search_key , @params = company_id, @params = sort_key, @params = sort_value*/
                let params = {
                    search_key: item || '',
                    sort_key: "customer_name",
                    sort_value: -1,
                    limit: 10,
                    skip : 0,
                    status: "active"
                }
                let response = await this.getCustomerList(params)
                this.counterparty_options = response.response
                this.counterparty_options.forEach(x => {
                    this.store_invitees.push(x)
                })
                //filtering the same data from invite options to avoid redundancy
                this.counterparty_options = this.counterparty_options.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.counterparty_options.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.customer_count = this.counterparty_options.length
                this.customer_loading = false
                this.customer_scrollable = false
            },
            //lazy loading of invites
            async reachedEndOfListCounterparty(reached) {
                this.customer_visible = reached
                if (reached) {
                    if (this.customer_scrollable == false) {
                        this.customer_loading = true
                        /**@params = limit, @params = skip , @params = search_key , @params = company_id, @params = sort_key, @params = sort_value*/
                        let response = await this.getCustomerList({
                            search_key: "",
                            sort_key: "customer_name",
                            sort_value: -1,
                            limit: 10,
                            skip : this.customer_count,
                            status: "active"
                        })
                        this.temp_customer = response.response.length;
                        if (response.skip == this.customer_count) {
                            if (this.temp_customer > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.counterparty_options.push(el);
                                });
                                this.counterparty_options = this.counterparty_options.filter((thing, index) => {
                                    const payload = JSON.stringify(thing);
                                    return index === this.counterparty_options.findIndex(obj => {
                                        return JSON.stringify(obj) === payload;
                                    });
                                });
                                this.customer_count += response.response.length;
                                this.customer_loading = false
                            } else {
                                this.customer_scrollable = true
                                this.customer_loading = false
                            }
                        }
                        this.customer_loading = false
                    }
                }
            },
            async searchInviteesDebouncer(item) {
                this.employees_loading = true
                /**@params = limit, @params = skip , @params = search_key , @params = company_id, @params = sort_key, @params = sort_value*/
                let params = {
                    skip: 0,
                    limit: 50,
                    search_key: item,
                    company_id: this.loggedInUser.company_id,
                    sort_key: 'full_name',
                    sort_value: 1
                }
                let response = await this.getAssigned(params)
                this.invite_options = response.response
                this.invite_options.forEach(x => {
                    this.store_invitees.push(x)
                })
                //filtering the same data from invite options to avoid redundancy
                this.invite_options = this.invite_options.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.invite_options.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.employee_count = this.invite_options.length
                this.employees_loading = false
                this.employee_scrollable = false
            },
            //lazy loading of invites
            async reachedEndOfListInvitees(reached) {
                this.employee_visible = reached
                if (reached) {
                    if (this.employee_scrollable == false) {
                        this.employees_loading = true
                        /**@params = limit, @params = skip , @params = search_key , @params = company_id, @params = sort_key, @params = sort_value*/
                        let response = await this.getAssigned({
                            skip: this.employee_count,
                            limit: 10,
                            search_key: "",
                            company_id: this.loggedInUser.company_id,
                            sort_key: 'full_name',
                            sort_value: 1
                        })
                        this.temp_employees = response.response.length;
                        if (response.skip == this.employee_count) {
                            if (this.temp_employees > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.invite_options.push(el);
                                });
                                this.invite_options = this.invite_options.filter((thing, index) => {
                                    const payload = JSON.stringify(thing);
                                    return index === this.invite_options.findIndex(obj => {
                                        return JSON.stringify(obj) === payload;
                                    });
                                });
                                this.employee_count += response.response.length;
                                this.employees_loading = false
                            } else {
                                this.employee_scrollable = true
                                this.employees_loading = false
                            }
                        }
                        this.employees_loading = false
                    }
                }
            },
            limitCounterparty(count) {
                return `+ ${count} more`
            },
            hideScheduleMeeting() {
                this.$emit("hideScheduleMeeting", false)
            },
            allDayChecked() {
                let curr_date = moment(new Date().toUTCString()).format("YYYY-MM-DD")
                if (this.all_day == true) {
                    this.allDayTime = true
                    if(this.schedule_start_date == curr_date){
                        this.schedule_end_date = ""
                        this.schedule_start_date = ""
                    }
                    this.schedule_start_time = ""
                    this.schedule_end_time = ""
                    let start_date = new Date()
                    start_date.setDate(start_date.getDate() + 1)
                    this.disable_today_date = start_date
                    this.$forceUpdate()
                } else {
                    this.allDayTime = false
                    this.$forceUpdate()
                }
            },
            addGoogleCal(){
                if (this.add_cal == true) {
                    this.addGoogle = true
                    this.$forceUpdate()
                } else {
                    this.addGoogle = false
                    this.$forceUpdate()
                }
            },
            async getMeetingData(){
                let params = {
                    id: this.meeting_data_id
                }
                let response = await this.getScheduleMeetingById(params)
                this.meeting_title = response.response.meeting_title,
                this.counterparty = response.response.customer_details,
                this.schedule_start_date = response.response.start_date,
                this.schedule_start_time = response.response.start_time,
                this.schedule_end_date = response.response.end_date,
                this.schedule_end_time = response.response.end_time,
                this.all_day = response.response.all_day,
                this.invitees =response.response.invitees,
                this.tags = response.response.other_invitees,
                this.description = response.response.description,
                this.meeting_notes_table = response.response.agenda_info.table_details,
                // this.meeting_notes_table = response.
                this.add_cal = response.response.add_to_google_cal
                this.stringified_bus_response = JSON.stringify(this.create_schedule_meeting)
            },
            selectInvitees(data){
                this.temp_selected_invitees.push({
                    email: data.email,
                    id: data.user_id,
                    full_name: data.full_name
                })
            },
        },
        mounted(){
            if(this.view_mode == 'edit'){
                this.getMeetingData();
            }
        },
        computed: {
            create_schedule_meeting(){
                let temp_ot_inviteees = []
                this.tags.forEach(x => {
                    temp_ot_inviteees.push(x.text)
                })
                return {
                    _id:this.meeting_data_id,
                    "product_name": "CRM",
                    "origin": this.module_type,
                    "meeting_title": this.meeting_title,
                    "customer_details": this.selectedCustomer,
                    "start_date": this.schedule_start_date,
                    "start_time": this.schedule_start_time,
                    "end_date": this.schedule_end_date,
                    "end_time": this.schedule_end_time,
                    "all_day": this.all_day,
                    "invitees": this.temp_selected_invitees,
                    "other_invitees": temp_ot_inviteees,
                    "description": this.description,
                    "agenda_info": {
                        no_of_tables: this.meeting_notes_table.length,
                        table_details: this.temp_table_details
                    },
                    "add_to_google_cal": this.add_cal,
                    "reference_id": this.reference_id,
                    "stage_name": this.lead_current_stage
                }
            },
            fields_not_changed_bus(){
                return this.stringified_bus_response == JSON.stringify(this.create_schedule_meeting)
            },
            loggedInUser() {
                return this.$store.state.loggedInUser;
            },
        }
    })
</script>
<style>
    .bg-color{
        background-color: #00448b;
        color:#fff !important;
        border-radius: 4px;
    }
    .description {
        border: solid 1px #000 !important;
        border-radius: 5px !important;
        text-transform: capitalize;
        color: #000000;
        width: 100%;
    }
    .table-div{
        border: 1px solid black;
        border-radius: 5px;
        height: auto;
    }
    .template-data-table>tbody>tr:first-child td, .template-data-table>tbody>tr:first-child td input {
        background: #fff !important;
        color: #303031 !important;
        border-bottom: 0px solid #fff !important;
    }
    .template-data-table>tbody>tr:first-child td {
         border: 0.5px solid #303031 !important;
    }
    .template-data-table tbody tr td input {
        font-weight: 600;
        text-align: left !important;
        border-bottom: 0px solid #000 !important;
    }
    .template-data-table thead tr th {
        background: #00448b;
        color: #fff;
        padding: 10px 30px;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
        border: 1px solid #000 !important;
    }
    
    .template-data-table thead tr th:first-child {
        border-top-left-radius: 5px;
    }
    .template-data-table thead tr th:last-child {
        border-top-right-radius: 5px;
    }
    .template-data-table>thead>tr>th input {
        background: #00448B !important;
        color: #ffffff !important;
        border-bottom: 0px solid #fff !important;
    }
    .template-data-table>tbody>tr:first-child td input::placeholder{
        color: #7b7f83 !important;
    }
    .table-box{
        box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.41);
        background-color: #fff;
        border-radius: 10px;
    }
    .new-back-button{
        padding: 0 10px 0 0px !important;
        border-radius: 5px !important;
        font-size: 14px !important;
        line-height: 30px !important;
        text-transform: none !important;
        font-weight: 600 !important;
        color: #00448b !important;
        background-color: #fff !important;
        border: 1px solid #00448b !important;
    }
    .meeting-table tbody tr td {
		border: 0.5px solid rgba(0, 0, 0, 0.35);
        padding: 0 15px !important;
	}

	.meeting-table>tbody>tr:first-child td {
		border-top: 0px !important;
		border-bottom: 0px !important;
	}

	.meeting-table>tbody>tr:first-child td:first-child {
		border-top-left-radius: 5px;
	}

	.meeting-table>tbody>tr:first-child td:last-child {
		border-top-right-radius: 5px;
	}

	.meeting-table tbody tr td input {
		font-weight: 600;
		text-align: left;
        border-bottom: 1px solid rgba(0, 0, 0, 0.41) !important;
	}

	.meeting-table>tbody>tr:first-child td,
	.meeting-table>tbody>tr:first-child td input {
        border-bottom: 0px solid rgba(0, 0, 0, 0.41) !important;
		background: #00448b !important;
		color: #ffffff !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/ScheduleMeeting/CreateScheduleMeeting.vue